// namespace
export const PROFILE_NAMESPACE = 'profile'

// getters
export const PROFILE_GETTER = 'profile'

// mutations
export const PROFILE_MUTATION_SINGLE_ENTRY = 'updateProfileFromSingleEntry'
export const PROFILE_MUTATION_ENTIRE_PROFILE = 'updateEntireProfile'

// actions
export const PROFILE_ACTION_GET_PROFILE = 'fetchProfile'
export const PROFILE_ACTION_SAVE_PROFILE = 'saveProfile'



// WEBPACK FOOTER //
// ./src/store/modules/profile-types.js